/**
 * Where assets and API live when the UI is bundled inside the native WebView.
 *
 * The shell serves the page from `https://localhost`, so a relative `/audio/...` or
 * `/api/auth/...` would hit the APK's own asset bundle rather than the site. The PWA
 * must keep resolving relatively — a default of the production origin would change
 * every existing URL — which is why the web branch returns the empty string.
 */

import { Capacitor } from '@capacitor/core';

export const REMOTE_ORIGIN = 'https://ajahnbrahm.pages.dev';

/**
 * Tests inject the platform bit here rather than mocking `@capacitor/core`.
 *
 * A hostname or UA check would treat a local `vite` preview on localhost as the
 * native shell and start fetching production, which is the failure this file
 * exists to prevent. Capacitor is the only signal that actually means the APK.
 */
let nativeForTest: boolean | null = null;

export function __setNativeForTest(value: boolean | null): void {
  nativeForTest = value;
}

export function isNativeShell(): boolean {
  return nativeForTest ?? Capacitor.isNativePlatform();
}

export function apiOrigin(): string {
  return isNativeShell() ? REMOTE_ORIGIN : '';
}

export function assetOrigin(): string {
  return isNativeShell() ? REMOTE_ORIGIN : '';
}
